/* ============================================================
   ALAN KOCH — storefront interactions
   Drawers · dark mode · splash · AJAX cart · toast · PDP gallery
   + lightbox · accordions · grid toggle · filter sheet · points
   ============================================================ */
(function () {
  'use strict';
  var AK = window.AK || {};
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = AK.moneyFormat || '₹{{amount}}';
    var amount = (cents / 100);
    var str = amount.toLocaleString('en-IN', { maximumFractionDigits: amount % 1 ? 2 : 0 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, str);
  }
  AK.money = money;

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg) {
    toastEl = toastEl || $('[data-ak-toast]');
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.hidden = false;
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.hidden = true; }, 1600);
  }
  AK.toast = toast;

  /* ---------- loading screen ---------- */
  function loaderEl() { return $('[data-ak-loader]'); }
  function positionLoader() {
    // under .ak-dark the body has a filter → fixed elements use the body box as containing block,
    // so offset the loader by the current scroll to keep it pinned to the viewport.
    var l = loaderEl(); if (!l) return;
    l.style.top = document.body.classList.contains('ak-dark') ? (window.scrollY || 0) + 'px' : '0px';
  }
  function hideLoader() { var l = loaderEl(); if (l) l.classList.add('is-done'); }
  function showLoader() { var l = loaderEl(); if (l) { positionLoader(); l.style.visibility = ''; l.classList.remove('is-done'); } }
  positionLoader();
  AK.hideLoader = hideLoader; AK.showLoader = showLoader;
  /* pin a fixed overlay to the current viewport — under .ak-dark the body filter makes
     position:fixed resolve to the (tall) document, so offset by scroll to keep it on-screen */
  function pinViewport(el) { if (el) el.style.top = document.body.classList.contains('ak-dark') ? (window.scrollY || 0) + 'px' : '0px'; }
  AK.pinViewport = pinViewport;
  window.addEventListener('pageshow', function (e) { if (e.persisted) hideLoader(); });
  setTimeout(hideLoader, 5000); // safety net so it can never get stuck
  /* note: intro loader shows once per session (first entry) only — see the sessionStorage gate
     in the head. No loader on internal navigation, matching luxury-storefront convention. */

  /* ---------- backdrop + drawers ---------- */
  var backdrop, bdHideT;
  function openDrawer(sel) {
    var d = $(sel); if (!d) return;
    backdrop = backdrop || $('[data-ak-backdrop]');
    closeDrawers(true);            // close any other open drawer, but keep the backdrop up
    clearTimeout(bdHideT);         // cancel any pending backdrop hide so it can't vanish under us
    pinViewport(d);                // dark mode body-filter breaks position:fixed → pin to viewport
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (backdrop) { backdrop.hidden = false; requestAnimationFrame(function () { backdrop.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers(silent) {
    $$('.ak-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    if (silent) return;            // silent = mid-reopen: leave the backdrop & scroll lock in place
    if (backdrop) { backdrop.classList.remove('is-open'); clearTimeout(bdHideT); bdHideT = setTimeout(function () { backdrop.hidden = true; }, 300); }
    document.body.style.overflow = '';
  }
  AK.openDrawer = openDrawer;
  AK.closeDrawers = closeDrawers;

  /* ---------- dark mode ---------- */
  function applyDark(on) {
    document.body.classList.toggle('ak-dark', on);
    try { localStorage.setItem('ak-dark', on ? '1' : '0'); } catch (e) {}
    $$('[data-ak-darktoggle]').forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
  }
  function initDark() {
    var stored;
    try { stored = localStorage.getItem('ak-dark'); } catch (e) {}
    if (stored !== null) applyDark(stored === '1');
  }

  /* ---------- splash (region/language, once) ---------- */
  function initSplash() {
    var sheet = $('[data-ak-splash]'); if (!sheet) return;
    var seen;
    try { seen = localStorage.getItem('ak-splash-seen'); } catch (e) {}
    if (!seen) { sheet.hidden = false; document.body.style.overflow = 'hidden'; }
    $$('[data-ak-splash-close]', sheet).forEach(function (b) {
      b.addEventListener('click', function () {
        sheet.hidden = true; document.body.style.overflow = '';
        try { localStorage.setItem('ak-splash-seen', '1'); } catch (e) {}
      });
    });
  }

  /* ---------- AJAX cart ---------- */
  function cartFetch(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function refreshCart() {
    return fetch(AK.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }
  function addToCart(id, qty, props) {
    var body = { items: [{ id: id, quantity: qty || 1 }] };
    if (props) body.items[0].properties = props;
    return cartFetch(AK.routes.cartAdd, body).then(function (res) {
      toast('Added to basket');
      return refreshCart().then(function () { return res; });
    });
  }
  function changeLine(key, qty) {
    return cartFetch(AK.routes.cartChange, { id: key, quantity: qty }).then(function (cart) { renderCart(cart); return cart; });
  }
  AK.addToCart = addToCart;
  AK.changeLine = changeLine;
  AK.refreshCart = refreshCart;

  /* ----- cross-sell pools + gamification state ----- */
  var ADDONS = [], PAIRING = [], SUGGEST = [];
  var soSub = 'All', soTarget = null, soPool = [], pendingRemove = null, lastCart = null, cartSubs = [];
  AK.onCart = function (cb) { cartSubs.push(cb); if (lastCart) cb(lastCart); };
  AK.lineForVariant = function (vid) { if (!lastCart) return null; vid = String(vid); return lastCart.items.filter(function (i) { return String(i.variant_id) === vid && !isAddon(i); })[0] || null; };
  function jsonFrom(sel) { var el = $(sel); if (!el) return []; try { return JSON.parse(el.textContent) || []; } catch (e) { return []; } }
  function loadPools() { ADDONS = jsonFrom('[data-ak-addons]'); PAIRING = jsonFrom('[data-ak-pairing]'); SUGGEST = jsonFrom('[data-ak-suggest]'); }

  function pointsFor(cents) { return Math.round((cents / 100) * (AK.settings.pointsRate || 0.1)); }
  function rate() { return AK.settings.pointsRate || 0.1; }
  function mult() { return AK.settings.addonMultiplier || 1.5; }
  function sessGet() { try { return parseInt(localStorage.getItem('ak-sess-pts') || '0', 10) || 0; } catch (e) { return 0; } }
  function sessSet(n) { try { localStorage.setItem('ak-sess-pts', String(Math.max(0, n))); } catch (e) {} }
  function isAddon(it) { return !!(it.properties && (it.properties._addon === 'true' || it.properties._addon === true)); }
  function cartBasePoints(cart) { return cart.items.reduce(function (a, it) { return isAddon(it) ? a : a + pointsFor(it.final_line_price); }, 0); }
  function thumb(url, px) { if (!url) return ''; return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + (px || 200) + 'x$1$2'); }

  /* ----- membership points: flat per-SKU value + vest/sock 1.5× multiplier ----- */
  function itemBasePoints(it) {
    var vendor = it.vendor || ''; var t = (it.product_title || it.title || '').toLowerCase();
    if (vendor && vendor !== 'Alan Koch') return 150;                            /* women — anything */
    if (/sock|vest/.test(t)) return 0;                                           /* quick add-ons: multiplier only */
    if (/t-shirt|tshirt|\btee\b/.test(t)) return 20;                             /* tees */
    if (/trouser|pant|jean|denim|short|chino|jogger|cargo/.test(t)) return 60;   /* bottoms */
    return 40;                                                                   /* shirts, polos, tops */
  }
  function cartHasMultiplier(cart) { return !!(cart && cart.items && cart.items.some(function (it) { return /sock|vest/.test((it.product_title || it.title || '').toLowerCase()); })); }
  function cartTotalPoints(cart) {
    if (!cart || !cart.items) return 0;
    var base = cart.items.reduce(function (a, it) { return a + itemBasePoints(it) * it.quantity; }, 0);
    return Math.round(base * (cartHasMultiplier(cart) ? mult() : 1));
  }
  function isLoggedIn() { return !!(AK.account && AK.account.loggedIn); }
  function walletKey() { return 'ak-wallet:' + ((AK.account && AK.account.id) || 'anon'); }
  function walletGet() { try { return parseInt(localStorage.getItem(walletKey()) || '0', 10) || 0; } catch (e) { return 0; } }
  function walletAdd(n) { try { localStorage.setItem(walletKey(), String(walletGet() + Math.max(0, n))); } catch (e) {} }
  function pendingGet() { try { return parseInt(localStorage.getItem('ak-pending-pts') || '0', 10) || 0; } catch (e) { return 0; } }
  function pendingSet(n) { try { if (n > 0) localStorage.setItem('ak-pending-pts', String(n)); else localStorage.removeItem('ak-pending-pts'); } catch (e) {} }
  function loginUrlWithReturn(ret) {
    var u = (AK.routes && (AK.routes.login || AK.routes.account)) || '/account/login';
    return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'return_url=' + encodeURIComponent(ret || '/');
  }
  AK.loginUrlWithReturn = loginUrlWithReturn;
  function doClaim() {
    var total = cartTotalPoints(lastCart);
    if (isLoggedIn()) { walletAdd(total); toast(total.toLocaleString('en-IN') + ' points added to your wallet'); if (lastCart) renderCart(lastCart); return; }
    pendingSet(total);
    location.href = loginUrlWithReturn('/');
  }

  function renderCart(cart) {
    lastCart = cart;
    $$('[data-ak-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    var body = $('[data-ak-cart-body]'); if (!body) return;
    if (!cart.item_count) { body.innerHTML = emptyCartHTML(); var fe0 = $('[data-ak-cart-foot]'); if (fe0) { fe0.hidden = true; fe0.innerHTML = ''; } sessSet(0); cartSubs.forEach(function (cb) { try { cb(cart); } catch (e) {} }); return; }

    var cartProductIds = cart.items.map(function (i) { return i.product_id; });

    /* free-delivery banner */
    var ship = '<div class="ak-cart-ship">You’ve got free standard delivery to your home</div>';

    /* lines */
    var lines = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + thumb(it.image, 360) + '" alt="" class="ak-fill">' : '<span class="ak-ph"></span>';
      var dec = isAddon(it)
        ? '<button data-ak-addon-dec="' + it.key + '" data-pts="' + (it.properties._pts || 0) + '" data-qty="' + it.quantity + '" aria-label="Decrease">−</button>'
        : '<button data-ak-dec="' + it.key + '" aria-label="Decrease">−</button>';
      var rm = isAddon(it)
        ? 'data-ak-addon-remove="' + it.key + '" data-pts="' + (it.properties._pts || 0) + '"'
        : 'data-ak-remove="' + it.key + '"';
      var variant = (it.variant_title || '').replace('Default Title', '');
      return '<div class="ak-cart-line"><div class="ak-cart-line__media">' + img + '</div>' +
        '<div class="ak-cart-line__info"><div class="ak-cart-line__top"><span class="ak-cart-line__name">' + it.product_title + '</span>' +
        '<button class="ak-x" ' + rm + ' aria-label="Remove">' + icon('close', 16) + '</button></div>' +
        '<div class="ak-cart-line__price2">' + money(it.final_line_price) + '</div>' +
        (variant ? '<div class="ak-cart-line__meta">' + variant + '</div>' : '') +
        '<div class="ak-stepper">' + dec + '<span>' + it.quantity + '</span><button data-ak-inc="' + it.key + '" aria-label="Increase">+</button></div>' +
        '</div></div>';
    }).join('');

    /* promotional code */
    var promo = '<div class="ak-cart-promo">' +
      '<button class="ak-cart-promo__bar" data-ak-promo-toggle><span>PROMOTIONAL CODE</span><span class="ak-cart-promo__add">ADD</span></button>' +
      '<form class="ak-cart-promo__form" data-ak-promo-form hidden><input type="text" name="code" placeholder="Enter code" autocomplete="off"><button type="submit">APPLY</button></form></div>';

    /* you may like — one 2-column grid from the suggestion pool */
    var pool = (SUGGEST.length ? SUGGEST : PAIRING).filter(function (p) { return cartProductIds.indexOf(p.pid) < 0; });
    var yml = '';
    if (pool.length) {
      yml = '<div class="ak-cart-yml"><div class="ak-cart-yml__h">YOU MAY LIKE</div><div class="ak-cart-yml__grid">' +
        pool.slice(0, 4).map(ymlCard).join('') + '</div></div>';
    }

    body.innerHTML = ship + '<div class="ak-cart-lines">' + lines + '</div>' + promo + yml;

    /* footer: subtotal / delivery / total / process order */
    var subt = (cart.items_subtotal_price != null) ? cart.items_subtotal_price : cart.total_price;
    var foot = '<div class="ak-cart-foot2">' +
      '<div class="ak-cart-row"><span>SUBTOTAL</span><span>' + money(subt) + '</span></div>' +
      '<div class="ak-cart-row"><span>DELIVERY COSTS</span><span class="ak-cart-free">FREE</span></div>' +
      '<div class="ak-cart-row ak-cart-row--total"><span>TOTAL</span><span>' + money(cart.total_price) + '</span></div>' +
      '<div class="ak-cart-taxnote">Taxes included, where applicable</div>' +
      '<form action="' + (AK.routes.cart || '/cart') + '" method="post" class="ak-cart-checkout"><button type="submit" name="checkout" class="ak-btn ak-btn--process">PROCESS ORDER</button></form></div>';

    var footEl = $('[data-ak-cart-foot]');
    if (footEl) { footEl.innerHTML = foot; var bp = $('[data-ak-cart-panel="basket"]'); footEl.hidden = !!(bp && bp.hidden); }
    $$('[data-ak-cart-tabcount]').forEach(function (el) { el.textContent = cart.item_count ? ' (' + cart.item_count + ')' : ''; });
    cartSubs.forEach(function (cb) { try { cb(cart); } catch (e) {} });
  }

  function railCard(p) {
    var img = p.img ? '<img src="' + p.img + '" alt="" class="ak-fill">' : '<span class="ak-ph"></span>';
    return '<div class="ak-pair"><a class="ak-pair__media" href="' + p.url + '">' + img +
      '<button class="ak-iconbtn" data-ak-add="' + p.id + '" aria-label="Add">' + icon('bag', 16) + '</button></a>' +
      '<a class="ak-pair__name" href="' + p.url + '">' + p.title + '</a><div class="ak-pair__price">' + money(p.price) + '</div></div>';
  }
  function ymlCard(p) {
    var img = p.img ? '<img src="' + p.img + '" alt="" class="ak-fill">' : '<span class="ak-ph"></span>';
    return '<div class="ak-cart-yml__card"><a class="ak-cart-yml__media" href="' + p.url + '">' + img + '</a>' +
      '<button class="ak-cart-yml__add" data-ak-add="' + p.id + '" aria-label="Add">' + icon('plus', 15) + '</button>' +
      '<a class="ak-cart-yml__name" href="' + p.url + '">' + p.title + '</a><div class="ak-cart-yml__price">' + money(p.price) + '</div></div>';
  }
  function soProducts() {
    var f = (soSub === 'All') ? soPool : soPool.filter(function (p) { return p.sub === soSub; });
    if (!f.length) f = soPool;
    return f.slice(0, 8).map(railCard).join('');
  }
  function settingsLink() { return (AK.routes.cart || '').replace(/\/cart.*/, '') + '/pages/membership'; }
  function emptyCartHTML() {
    return '<div class="ak-cart-empty">' + icon('bag', 46) +
      '<div class="ak-cart-empty__h">EMPTY BASKET</div>' +
      '<div class="ak-cart-empty__p">Your basket is still empty — discover everything we’ve made for you.</div>' +
      '<button class="ak-btn" data-ak-close-drawer>DISCOVER</button></div>';
  }

  /* ----- quick add-on add: award multiplied points + confetti popup ----- */
  function addAddon(variantId) {
    cartFetch(AK.routes.cartAdd, { items: [{ id: variantId, quantity: 1, properties: { _addon: 'true' } }] })
      .then(function () { return refreshCart(); })
      .then(function (cart) { showPointsPopup(cartTotalPoints(cart)); });
  }
  function showPointsPopup(total) {
    var pop = $('[data-ak-points-popup]'); if (!pop) return;
    var p1 = $('[data-ak-popup-pts]', pop); if (p1) p1.textContent = total.toLocaleString('en-IN') + ' points';
    var p2 = $('[data-ak-popup-sess]', pop); if (p2) p2.textContent = isLoggedIn() ? 'on this order' : 'sign up to claim';
    var box = $('[data-ak-confetti]', pop);
    if (box) {
      var cols = ['#C9B79C', '#1B7A4B', '#1A1714', '#D9A441', '#B7AE9C'];
      box.innerHTML = Array.from({ length: 16 }, function (_, i) {
        return '<span style="position:absolute;top:-6px;left:' + Math.round((i / 16) * 100) + '%;width:7px;height:10px;background:' + cols[i % 5] +
          ';border-radius:1px;opacity:.9;animation:akConfetti ' + (1 + (i % 5) * 0.22).toFixed(2) + 's ' + ((i % 7) * 0.06).toFixed(2) + 's ease-in forwards;transform:rotate(' + (i * 33 % 360) + 'deg);"></span>';
      }).join('');
    }
    pop.hidden = false;
    clearTimeout(pop._t);
    pop._t = setTimeout(function () { pop.hidden = true; }, 3200);
  }

  function addAndUpsell(id) {
    return addToCart(id, 1).then(function () { openDrawer('[data-ak-drawer-cart]'); });
  }
  AK.addAndUpsell = addAndUpsell;

  /* ---------- icons (inline, ported strokes) ---------- */
  function icon(name, s) {
    s = s || 22;
    var W = 'width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"';
    var P = {
      close: '<path d="M6 6l12 12M18 6 6 18"/>',
      bag: '<path d="M6 8h12l-1 12H7L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/>',
      search: '<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>',
      menu: '<path d="M3 6h18M3 12h18M3 18h18"/>',
      star: '<path d="M12 3l2.4 5 5.6.8-4 3.9 1 5.5L12 21l-5 2.7 1-5.5-4-3.9 5.6-.8z"/>',
      arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
      chevL: '<path d="M15 5l-7 7 7 7"/>',
      user: '<circle cx="12" cy="8" r="3.5"/><path d="M5 20a7 7 0 0 1 14 0"/>',
      plus: '<path d="M12 5v14M5 12h14"/>',
      bookmark: '<path d="M7 4h10v16l-5-3.5L7 20V4Z"/>'
    };
    return '<svg ' + W + '>' + (P[name] || '') + '</svg>';
  }
  AK.icon = icon;

  /* ---------- PDP gallery: dots + lightbox ---------- */
  function initGallery(root) {
    var rail = $('[data-ak-gallery]', root); if (!rail) return;
    var dots = $$('[data-ak-dot]', root);
    rail.addEventListener('scroll', function () {
      var i = Math.round(rail.scrollLeft / rail.clientWidth);
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' }); });
    });
    $$('[data-ak-zoom]', rail).forEach(function (fig, i) {
      fig.addEventListener('click', function () { openLightbox(root, i); });
    });
  }
  function openLightbox(root, i) {
    var lb = $('[data-ak-lightbox]', root); if (!lb) return;
    var imgs = $$('[data-ak-gallery] img', root).map(function (im) { return im.currentSrc || im.src; });
    var idx = i, z = 1, ox = 0, oy = 0;
    var content = $('[data-ak-lb-content]', lb);
    var imgEl = $('[data-ak-lb-img]', lb);
    function show() { imgEl.src = imgs[idx]; apply(); }
    function apply() { content.style.transform = 'translate(' + ox + 'px,' + oy + 'px) scale(' + z + ')'; content.style.cursor = z > 1 ? 'grab' : 'zoom-in'; }
    show(); lb.hidden = false; document.body.style.overflow = 'hidden';
    lb._close = function () { lb.hidden = true; document.body.style.overflow = ''; };
    $$('[data-ak-lb-close]', lb).forEach(function (b) { b.onclick = lb._close; });
    $('[data-ak-lb-prev]', lb).onclick = function () { idx = Math.max(0, idx - 1); z = 1; ox = oy = 0; show(); };
    $('[data-ak-lb-next]', lb).onclick = function () { idx = Math.min(imgs.length - 1, idx + 1); z = 1; ox = oy = 0; show(); };
    content.ondblclick = function () { z = z > 1 ? 1 : 2.5; ox = oy = 0; apply(); };
    content.onwheel = function (e) { e.preventDefault(); z = Math.max(1, Math.min(4, z * (e.deltaY < 0 ? 1.18 : 0.85))); if (z <= 1) { ox = oy = 0; } apply(); };
  }

  /* ---------- accordions ---------- */
  function initAccordions(root) {
    $$('[data-ak-acc]', root).forEach(function (acc) {
      var head = $('[data-ak-acc-head]', acc);
      if (head) head.addEventListener('click', function () { acc.classList.toggle('is-open'); });
    });
  }

  /* ---------- PLP grid toggle + filter sheet ---------- */
  function initPlp(root) {
    var grid = $('[data-ak-plp-grid]', root);
    $$('[data-ak-grid]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.getAttribute('data-ak-grid');
        if (grid) grid.setAttribute('data-cols', n);
        $$('[data-ak-grid]', root).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        try { localStorage.setItem('ak-grid', n); } catch (e) {}
      });
    });
    var stored;
    try { stored = localStorage.getItem('ak-grid'); } catch (e) {}
    if (stored && grid && !grid.hasAttribute('data-grid-lock')) {
      grid.setAttribute('data-cols', stored);
      $$('[data-ak-grid]', root).forEach(function (x) { x.classList.toggle('is-active', x.getAttribute('data-ak-grid') === stored); });
    }
    var sheet = $('[data-ak-filter]', root);
    if (sheet) {
      function closeFilter() { sheet.hidden = true; document.body.style.overflow = ''; }
      $$('[data-ak-filter-open]', root).forEach(function (b) { b.addEventListener('click', function () { pinViewport(sheet); sheet.hidden = false; document.body.style.overflow = 'hidden'; }); });
      $$('[data-ak-filter-close]', sheet).forEach(function (b) { b.addEventListener('click', closeFilter); });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) closeFilter(); });   // tap dim area to close
    }
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ak-open]');
    if (t) {
      var what = t.getAttribute('data-ak-open');
      if (what === 'menu') { e.preventDefault(); openDrawer('[data-ak-drawer-menu]'); return; }
      if (what === 'cart') { e.preventDefault(); closeAddonSheet(); openDrawer('[data-ak-drawer-cart]'); refreshCart(); return; }
      if (what === 'favourites') { e.preventDefault(); closeAddonSheet(); openDrawer('[data-ak-drawer-cart]'); var ft = document.querySelector('[data-ak-cart-tab="fav"]'); if (ft) ft.click(); return; }
      if (what === 'membership') { /* allow link navigation */ }
    }
    if (e.target.closest('[data-ak-backdrop]') || e.target.closest('[data-ak-close-drawer]')) { closeDrawers(); return; }
    var dark = e.target.closest('[data-ak-darktoggle]');
    if (dark) { applyDark(!document.body.classList.contains('ak-dark')); return; }

    var add = e.target.closest('[data-ak-add]');
    if (add) { e.preventDefault(); addAndUpsell(add.getAttribute('data-ak-add')); return; }

    var aadd = e.target.closest('[data-ak-addon-add]');
    if (aadd) { e.preventDefault(); addAddon(aadd.getAttribute('data-ak-addon-add'), parseInt(aadd.getAttribute('data-price'), 10) || 0); return; }

    var sub = e.target.closest('[data-ak-sub]');
    if (sub) { setSub(sub.getAttribute('data-ak-sub')); return; }

    var adec = e.target.closest('[data-ak-addon-dec]');
    if (adec) {
      var aq = parseInt(adec.getAttribute('data-qty'), 10) || 1;
      if (aq <= 1) requestRemoveAddon(adec.getAttribute('data-ak-addon-dec'), parseInt(adec.getAttribute('data-pts'), 10) || 0);
      else stepLine(adec.getAttribute('data-ak-addon-dec'), -1);
      return;
    }
    var arem = e.target.closest('[data-ak-addon-remove]');
    if (arem) { requestRemoveAddon(arem.getAttribute('data-ak-addon-remove'), parseInt(arem.getAttribute('data-pts'), 10) || 0); return; }

    if (e.target.closest('[data-ak-addon-sheet-close]') || (e.target.matches && e.target.matches('[data-ak-addon-sheet]'))) { closeAddonSheet(); }
    if (e.target.closest('[data-ak-points-popup]')) { var pp = $('[data-ak-points-popup]'); if (pp) { pp.hidden = true; clearTimeout(pp._t); } }
    if (e.target.closest('[data-ak-remove-keep]') || (e.target.matches && e.target.matches('[data-ak-remove-confirm]'))) { closeRemoveConfirm(); return; }
    if (e.target.closest('[data-ak-remove-yes]')) { doRemoveAddon(); return; }

    var rem = e.target.closest('[data-ak-remove]'); if (rem) { changeLine(rem.getAttribute('data-ak-remove'), 0); return; }
    var inc = e.target.closest('[data-ak-inc]'); if (inc) { stepLine(inc.getAttribute('data-ak-inc'), 1); return; }
    var dec = e.target.closest('[data-ak-dec]'); if (dec) { stepLine(dec.getAttribute('data-ak-dec'), -1); return; }

    var claim = e.target.closest('[data-ak-claim]'); if (claim) { e.preventDefault(); doClaim(); return; }
    if (e.target.closest('[data-ak-auth-close]') || (e.target.matches && e.target.matches('[data-ak-auth-prompt]'))) { var ap = $('[data-ak-auth-prompt]'); if (ap) ap.hidden = true; return; }

    var frm = e.target.closest('[data-ak-fav-remove]');
    if (frm) {
      e.preventDefault(); e.stopPropagation();   // card media is a link — never navigate on remove
      var flist = getFavs(), fid = frm.getAttribute('data-ak-fav-remove');
      var fidx = flist.map(function (f) { return f.id; }).indexOf(fid);
      if (fidx >= 0) { flist.splice(fidx, 1); setFavs(flist); markFavs(); renderFavs(); toast('Removed from favourites'); }
      return;
    }
    var fav = e.target.closest('[data-ak-fav]'); if (fav) { e.preventDefault(); toggleFav(fav); return; }
    var mvf = e.target.closest('[data-ak-move-fav]');
    if (mvf) {
      e.preventDefault();
      var favs = getFavs(), pid = mvf.getAttribute('data-pid');
      if (favs.map(function (f) { return f.id; }).indexOf(pid) < 0) {
        favs.push({ id: pid, url: mvf.getAttribute('data-url') || '#', title: mvf.getAttribute('data-title') || 'Saved item', price: money(parseInt(mvf.getAttribute('data-price'), 10) || 0), img: mvf.getAttribute('data-img') || '' });
        setFavs(favs); markFavs();
      }
      changeLine(mvf.getAttribute('data-ak-move-fav'), 0);
      toast('Moved to favourites');
      return;
    }
    var pt = e.target.closest('[data-ak-promo-toggle]');
    if (pt) { e.preventDefault(); var pf = pt.parentNode.querySelector('[data-ak-promo-form]'); if (pf) { pf.hidden = !pf.hidden; var inp = pf.querySelector('input'); if (inp && !pf.hidden) inp.focus(); } return; }
  });
  /* promotional code → apply via Shopify's /discount/<code> redirect */
  document.addEventListener('submit', function (e) {
    var pf = e.target && e.target.closest && e.target.closest('[data-ak-promo-form]');
    if (!pf) return;
    e.preventDefault();
    var code = ((pf.querySelector('input[name="code"]') || {}).value || '').trim();
    if (code) location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });

  function closeAddonSheet() { var s = $('[data-ak-addon-sheet]'); if (s) { s.hidden = true; document.body.style.overflow = ''; } }
  function setSub(s) {
    soSub = s;
    var rail = $('[data-ak-so-rail]'); if (rail) { rail.style.opacity = '0'; setTimeout(function () { rail.innerHTML = soProducts(); rail.style.opacity = '1'; }, 160); }
    $$('[data-ak-sub]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ak-sub') === s); });
  }
  function requestRemoveAddon(key) {
    /* bonus lost = current cart points (with ×1.5) − cart points once this add-on is gone */
    var before = cartTotalPoints(lastCart);
    var after = before;
    if (lastCart) { after = cartTotalPoints({ items: lastCart.items.filter(function (it) { return it.key !== key; }) }); }
    var lost = Math.max(0, before - after);
    pendingRemove = { key: key, pts: lost };
    var m = $('[data-ak-remove-confirm]'); if (!m) { changeLine(key, 0); return; }
    var lbl = $('[data-ak-remove-pts]', m); if (lbl) lbl.textContent = lost.toLocaleString('en-IN') + ' bonus points';
    m.hidden = false;
  }
  function closeRemoveConfirm() { pendingRemove = null; var m = $('[data-ak-remove-confirm]'); if (m) m.hidden = true; }
  function doRemoveAddon() {
    if (!pendingRemove) return;
    var p = pendingRemove; pendingRemove = null;
    var m = $('[data-ak-remove-confirm]'); if (m) m.hidden = true;
    changeLine(p.key, 0);
  }

  /* ---------- favourites (localStorage wishlist) ---------- */
  function getFavs() { try { return JSON.parse(localStorage.getItem('ak-favs') || '[]'); } catch (e) { return []; } }
  function setFavs(a) { try { localStorage.setItem('ak-favs', JSON.stringify(a)); } catch (e) {} }
  function toggleFav(btn) {
    var id = btn.getAttribute('data-ak-fav');
    var favs = getFavs();
    var idx = favs.map(function (f) { return f.id; }).indexOf(id);
    if (idx >= 0) { favs.splice(idx, 1); toast('Removed from favourites'); }
    else {
      var card = btn.closest('[data-ak-card]') || btn.closest('[data-ak-pdp]');
      var link = card ? card.querySelector('a[href]') : null;
      var img = card ? card.querySelector('img') : null;
      favs.push({
        id: id,
        url: link ? link.getAttribute('href') : '#',
        title: (card && card.querySelector('.ak-card__name') || {}).textContent || btn.getAttribute('data-fav-title') || 'Saved item',
        price: (card && card.querySelector('.ak-card__price') || {}).textContent || btn.getAttribute('data-fav-price') || '',
        img: img ? (img.currentSrc || img.src) : ''
      });
      toast('Saved to favourites');
    }
    setFavs(favs);
    markFavs();
    if (btn.closest('[data-ak-fav-body]')) renderFavs(); // un-bookmarked inside the drawer grid — keep it in sync
  }
  function showAuthPrompt() { var m = $('[data-ak-auth-prompt]'); if (m) m.hidden = false; }
  function renderProfile() {
    var body = $('[data-ak-profile-body]'); if (!body) return;
    if (isLoggedIn()) {
      body.innerHTML = '<div class="ak-profile">' +
        '<div class="ak-profile__hi">Hi ' + (AK.account.name || 'there') + '</div>' +
        '<div class="ak-profile__wallet"><div class="ak-profile__wlabel">MEMBER WALLET</div>' +
        '<div class="ak-profile__wpts">' + walletGet().toLocaleString('en-IN') + ' <span>points</span></div></div>' +
        '<a class="ak-btn ak-btn--block" href="' + (AK.routes.account || '/account') + '">VIEW ACCOUNT</a>' +
        '<a class="ak-profile__logout" href="' + (AK.routes.logout || '/account/logout') + '">Log out</a>' +
        '</div>';
    } else {
      body.innerHTML = '<div class="ak-profile ak-profile--guest">' +
        '<div class="ak-profile__badge">' + icon('user', 34) + '</div>' +
        '<div class="ak-profile__h">JOIN THE INNER CIRCLE</div>' +
        '<div class="ak-profile__p">Sign in with your email to claim your points, keep your favourites and unlock member rewards.</div>' +
        '<a class="ak-btn ak-btn--block" href="' + loginUrlWithReturn('/') + '">SIGN IN OR SIGN UP</a>' +
        '</div>';
    }
  }
  AK.renderProfile = renderProfile;
  function markFavs() {
    var ids = getFavs().map(function (f) { return f.id; });
    $$('[data-ak-fav]').forEach(function (b) {
      var on = ids.indexOf(b.getAttribute('data-ak-fav')) >= 0;
      b.classList.toggle('is-fav', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  var favEmptyHtml = null; // server-rendered "no favourites yet" state — cached before the first overwrite
  function renderFavs() {
    var body = $('[data-ak-fav-body]'); if (!body) return;
    if (favEmptyHtml === null) favEmptyHtml = body.innerHTML;
    var favs = getFavs();
    if (!favs.length) { body.innerHTML = favEmptyHtml; return; } // restore default empty state
    body.innerHTML = '<div class="ak-fav-grid">' + favs.map(function (f) {
      var media = f.img ? '<img src="' + f.img + '" alt="" class="ak-fill">' : '<span class="ak-ph"></span>';
      return '<div class="ak-card"><a class="ak-card__media" href="' + f.url + '" style="aspect-ratio:2/3;">' + media +
        '<button class="ak-iconbtn" data-ak-fav-remove="' + f.id + '" aria-label="Remove from favourites" style="position:absolute;top:8px;right:8px;">' + icon('close', 14) + '</button>' +
        '<div class="ak-card__actions"><button class="ak-iconbtn ak-fav is-fav" data-ak-fav="' + f.id + '" aria-label="Saved" aria-pressed="true">' + icon('bookmark', 16) + '</button></div></a>' +
        '<a class="ak-card__body" href="' + f.url + '"><div class="ak-card__name">' + f.title + '</div>' +
        '<div class="ak-card__price">' + f.price + '</div></a></div>';
    }).join('') + '</div>';
  }
  AK.renderFavs = renderFavs;

  /* ---------- product card colour swatches (from ak-colorways.json) ---------- */
  function colorways() {
    if (!window.__akColorways) {
      window.__akColorways = fetch(AK.colorwaysUrl).then(function (r) { return r.json(); }).catch(function () { return { products: {}, groups: {} }; });
    }
    return window.__akColorways;
  }
  AK.colorways = colorways;
  function renderCardSwatches(scope) {
    var els = $$('[data-ak-card-swatches]', scope); if (!els.length || !AK.colorwaysUrl) return;
    colorways().then(function (cat) {
      els.forEach(function (el) {
        if (el.getAttribute('data-done')) return;
        var cur = cat.products[el.getAttribute('data-handle')]; if (!cur) return;
        var sibs = (cat.groups[cur.group] || []).filter(function (x) { return cat.products[x]; });
        if (!sibs.length) return;
        el.setAttribute('data-done', '1');
        var max = 6, html = sibs.slice(0, max).map(function (x) {
          var s = cat.products[x];
          return '<span class="ak-card__sw" style="background:' + s.hex + ';" title="' + (s.colour || '') + '"></span>';
        }).join('');
        if (sibs.length > max) html += '<span class="ak-card__more">+' + (sibs.length - max) + '</span>';
        el.innerHTML = html;
      });
    });
  }
  AK.renderCardSwatches = renderCardSwatches;

  function stepLine(key, d) {
    fetch(AK.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (line) changeLine(key, Math.max(0, line.quantity + d));
      });
  }

  /* ---------- boot ---------- */
  /* akScreenIn animates transform with fill-mode:both, which keeps the animation applied
     forever — and an applied transform animation makes the section the containing block for
     position:fixed children (filter sheet, addon sheet …), shoving them off the viewport.
     Release the animation once the entrance has played so fixed overlays behave again. */
  function releaseScreenAnim() {
    $$('.ak-screen').forEach(function (s) { s.style.animation = 'none'; });
  }
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'akScreenIn' && e.target.classList.contains('ak-screen')) e.target.style.animation = 'none';
  });
  setTimeout(releaseScreenAnim, 1500); // fallback (reduced-motion / missed events)
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(hideLoader, 350);
    initDark();
    initSplash();
    loadPools();
    refreshCart();
    markFavs();
    if (isLoggedIn()) { var pend = pendingGet(); if (pend > 0) { walletAdd(pend); pendingSet(0); toast(pend.toLocaleString('en-IN') + ' points added to your wallet'); } }
    renderCardSwatches();
    $$('[data-ak-pdp]').forEach(function (r) { initGallery(r); initAccordions(r); });
    $$('[data-ak-plp]').forEach(initPlp);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var lb = $('[data-ak-lightbox]:not([hidden])'); if (lb && lb._close) { lb._close(); return; }
        closeDrawers();
        var open = $('[data-ak-filter]:not([hidden])'); if (open) { open.hidden = true; document.body.style.overflow = ''; }
      }
    });
  });
})();
